import React from 'react'

export type SpacerSize = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10'

interface SpacerProps {
  size: SpacerSize
}

export const Spacer: React.FC<SpacerProps> = ({ size }) => {
  return (
    <div
      style={{
        width: '100%',
        height: `var(--apkt-spacing-${size === '0' ? '0' : size})`
      }}
    />
  )
}

export default Spacer
